import getBasePath from '../../../../common/functions/api-resource';
import genericActions from './generic-resource';

const basePath = getBasePath('api', 'orcamento-tipo-verba');

const tipoOrcamentoActions = {
  ...genericActions(basePath),
  listarAtivos: { method: 'GET', url: `${basePath}?descInvestimento={nome}&indAtivo=true&colunaOrdenacao=nome` },
};

export default resource => resource(`${basePath}`, {}, tipoOrcamentoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/tipo-orcamento.js